import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoanImage from "./loan1.png";
import InvestmentImage from "./investment1.png";

export default function Feature() {
  const [loanData, setLoanData] = useState([]);
  const [investmentData, setInvestmentData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);

  const fetchLoanData = () => {
    axios.get("https://api.dremerz.net/api/bankshoppyloan")
      .then((res) => {
        setLoanData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios.get("https://api.dremerz.net/api/bankshoppyinvestment")
      .then((res) => {
        setInvestmentData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchLoanData();
  }, []);

  useEffect(() => {
    if (loanData.length > 0 && investmentData.length > 0) {
      const combined = [];
      const maxLength = Math.max(loanData.length, investmentData.length);
      for (let i = 0; i < maxLength; i++) {
        if (loanData[i]) combined.push({ ...loanData[i], type: 'loan' });
        if (investmentData[i]) combined.push({ ...investmentData[i], type: 'investment' });
      }
      setCombinedData(combined);
    }
  }, [loanData, investmentData]);

  return (
    <section className="pt-115 pb-105 feature-area-3">
      <div className="container">
        <div className="section-title">
          <span className="short-title-2">OUR Features</span>
          <h1 className="wow fadeInUp">We have better and more features</h1>
        </div>
        <div className="row gy-4 mt-50">
          {
            combinedData.map((data, index) => (
              <div className="col-xl-3 col-lg-4 col-md-6" key={index}>
                <div className="feature-card-widget-9 wow fadeInUp" data-wow-delay="0.3s">
                  <img 
                    src={data.type === 'loan' ? LoanImage : InvestmentImage} 
                    alt="" 
                    style={{ width: "100px", height: "100px" }}
                  />
                  <h5>{data.loanName}</h5>
                  <p>{data.bannerHeading}</p>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </section>
  );
}
